import { render, staticRenderFns } from "./DialogEditUserTeams.vue?vue&type=template&id=410f8676&scoped=true"
import script from "./DialogEditUserTeams.js?vue&type=script&lang=js&external"
export * from "./DialogEditUserTeams.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410f8676",
  null
  
)

export default component.exports